var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-input-string',_vm._g(_vm._b({directives:[{name:"strict-number",rawName:"v-strict-number",value:({
        enabled: _vm.strict,
        decimal: _vm.decimal,
        value: _vm.innateValue,
        'update:value': ($event) => (_vm.innateValue = $event),
    }),expression:"{\n        enabled: strict,\n        decimal,\n        value: innateValue,\n        'update:value': ($event) => (innateValue = $event),\n    }"}]},'iv-input-string',{
        ..._vm.$attrs,
        ..._vm.$props,
        value: undefined,
    },false),{
        ..._vm.$listeners,
        'update:value': () => {},
    }))
}
var staticRenderFns = []

export { render, staticRenderFns }